const SCOPE = 'prepare-disclosures.send';

export const SendStepTestIds = {
  ROOT: SCOPE,
  SUMMARY: `${SCOPE}.summary`,
  ATTESTATIONS: `${SCOPE}.attestations`,
  STATUS_NOTE: `${SCOPE}.status-note`,
  getAttestationId: type => `${SCOPE}.attestation-${type}`,
};
